var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{
      'light-theme': _vm.theme === 'light-theme',
      'dark-theme': _vm.theme === 'dark-theme',
    },attrs:{"id":"app"}},[(_vm.user)?_c('Navbar'):_vm._e(),_c('NotificationButton'),_c('v-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }